(function () {
  if (window.__aifruitChatInit) return;
  window.__aifruitChatInit = true;

  var IFRAME_SRC = 'https://aifruit.faanfruit.com';
  var MOBILE_BREAKPOINT = 750;

  function openOverlay(iframeSrc) {
    var overlay = document.createElement('div');
    overlay.className = 'aifruit-overlay is-open';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'aifruit-overlay__close';
    closeBtn.setAttribute('aria-label', 'Chiudi chat');
    closeBtn.textContent = '\u2715';

    var iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.title = 'Assistente AiFruit';

    overlay.appendChild(closeBtn);
    overlay.appendChild(iframe);

    var widgetsToHide = [];
    var poinzilla = document.getElementById('poinzilla-widget')
                 || document.querySelector('[id*="poinzilla" i]')
                 || document.querySelector('[class*="poinzilla" i]')
                 || document.querySelector('iframe[src*="poinzilla"]');
    if (poinzilla) widgetsToHide.push(poinzilla);

    ['CybotCookiebotDialog', 'CookiebotWidget', 'CybotCookiebotDialogBodyUnderlay'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) widgetsToHide.push(el);
    });
    var cookiebotFallback = document.querySelector('[class*="cookiebot" i]');
    if (cookiebotFallback && widgetsToHide.indexOf(cookiebotFallback) === -1) {
      widgetsToHide.push(cookiebotFallback);
    }

    widgetsToHide.forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });

    document.body.appendChild(overlay);

    var prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    closeBtn.addEventListener('click', function () {
      overlay.remove();
      document.body.style.overflow = prevOverflow;
      widgetsToHide.forEach(function (el) {
        el.style.removeProperty('display');
      });
    });
  }

  function openInline(wrapper, prompt, iframeSrc) {
    prompt.remove();
    wrapper.style.cursor = 'default';

    var iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.className = 'aifruit-chat__iframe';
    iframe.title = 'Assistente AiFruit';
    wrapper.appendChild(iframe);
  }

  function initInstance(wrapper) {
    if (wrapper.dataset.aifruitInited === '1') return;
    wrapper.dataset.aifruitInited = '1';

    var prompt = wrapper.querySelector('[data-aifruit-prompt]');
    if (!prompt) return;

    var iframeSrc = wrapper.getAttribute('data-aifruit-src') || IFRAME_SRC;

    prompt.addEventListener('click', function () {
      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        openOverlay(iframeSrc);
      } else {
        openInline(wrapper, prompt, iframeSrc);
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-aifruit-chat]').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
